// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"8fb82982","92":"5d5e3bab","204":"b05dd338","356":"4ac177b5","367":"23824de0","400":"9758ff9d","439":"a8c4220a","453":"a1da7bd1","508":"10b16798","608":"aa03d6c0","630":"afc2f2a9","817":"8393ed0c","835":"8e3b3f21","881":"e4be0804"}[chunkId] + ".chunk.js";
};